export default "__VITE_ASSET__d0e4d799__"